import { cn } from '@/lib/utils';
import type { PlaybookStatus } from '../services/playbooks.service';

export const STATUS_LABELS: Record<PlaybookStatus, string> = {
  draft: 'Rascunho',
  in_progress: 'Em execução',
  completed: 'Concluído',
  cancelled: 'Cancelado',
};

export const STATUS_BADGE_CLASS: Record<PlaybookStatus, string> = {
  draft:
    'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:border-slate-700',
  in_progress:
    'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-950 dark:text-blue-200 dark:border-blue-800',
  completed:
    'bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-200 dark:border-emerald-800',
  cancelled:
    'bg-red-100 text-red-800 border-red-200 dark:bg-red-950 dark:text-red-200 dark:border-red-800',
};

export const STATUS_ACCENT_CLASS: Record<PlaybookStatus, string> = {
  draft: 'bg-slate-400',
  in_progress: 'bg-blue-500',
  completed: 'bg-emerald-500',
  cancelled: 'bg-red-500',
};

export const STATUS_PROGRESS_CLASS: Record<PlaybookStatus, string> = {
  draft: '[&>div]:bg-slate-400',
  in_progress: '[&>div]:bg-blue-500',
  completed: '[&>div]:bg-emerald-500',
  cancelled: '[&>div]:bg-red-400',
};

export function getPlaybookProgress(stepsTotal: number, stepsCompleted: number) {
  if (stepsTotal <= 0) return 0;
  return Math.round((stepsCompleted / stepsTotal) * 100);
}

export function getProgressLabel(
  status: PlaybookStatus,
  stepsTotal: number,
  stepsCompleted: number,
) {
  if (stepsTotal === 0) return 'Sem etapas';
  if (status === 'draft') return `${stepsTotal} etapa(s) definida(s)`;
  if (status === 'cancelled') return `${stepsCompleted}/${stepsTotal} antes do cancelamento`;
  return `${stepsCompleted}/${stepsTotal} etapas`;
}

export function statusBadgeClass(status: PlaybookStatus) {
  return cn(
    'border font-medium shrink-0',
    STATUS_BADGE_CLASS[status] ?? STATUS_BADGE_CLASS.draft,
  );
}
